import EditProfileContent from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/EditProfile';
import { PersonalInfoContent } from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/PersonalInfo';
import MailSignatureContent from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/MailSignature';
import LanguageSettingContent from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/LanguageSetting';
import AlarmSettingContent from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/AlarmSetting';
import PasswordSettingContent from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/PasswordSetting';
import Vacation from 'components/MenuDrawer/MyMenuDrawer/SubMenu/Vacation';
import WorkHours from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/WorkHours';
import Overtime from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/Overtime';
import CertificateOfEmployment from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/CertificateOfEmployment';
import { PayStubContent } from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/PayStub';
import ShoppingMallVerification from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/ShoppingMallVerification';
import WifiContent from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/WifiContent';
import Olive from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/Olive';
import Wallet from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/Wallet';
import Settings from 'components/MenuDrawer/MyMenuDrawer/SubMenu/Settings';
import WorkingHoursChange from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/WorkingHoursChange';
import PortalAppDownload from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/PortalAppDownload';
import { HEALTH_CARE_BOOKING_URL } from '@/constant/url';

export enum MyMenuContent {
  MYPAGE = 'Mypage',
  EDIT_PROFILE = 'EditProfile',
  PERSONAL_INFO = 'PersonalInfo',
  MAIL_SIGNATURE = 'MailSignature',
  LANGUAGE_SETTING = 'LanguageSetting',
  ALARM_SETTING = 'AlarmSetting',
  PASSWORD_SETTING = 'PasswordSetting',
  CHECK_WORK_HOURS = 'WorkHours',
  CHECK_OVERTIME = 'CheckOvertime',
  CHECK_VACATION = 'CheckVacation',
  CERTIFICATE_OF_EMPLOYMENT = 'ProofEmployment',
  PAY_STUB = 'PayStub',
  SHOPPING_MALL_VERIFICATION = 'CertifyMallId',
  WIFI = 'Wifi',
  OLIVE = 'Olive',
  WALLET = 'Wallet',
  SETTINGS = 'Settings',
  WORKING_HOURS_CHANGE = 'WorkingHoursChange',
  PORTAL_APP_DOWNLOAD = 'PortalAppDownload',
  HEALTH_CARE_BOOKING = 'HealthCareBooking',
}

export const MyMenuContentTitle: { [key in MyMenuContent]: string } = {
  [MyMenuContent.MYPAGE]: '',
  [MyMenuContent.EDIT_PROFILE]: '프로필 편집',
  [MyMenuContent.PERSONAL_INFO]: '인사정보 조회',
  [MyMenuContent.MAIL_SIGNATURE]: '메일 서명',
  [MyMenuContent.LANGUAGE_SETTING]: '언어 설정',
  [MyMenuContent.ALARM_SETTING]: '알림 설정',
  [MyMenuContent.PASSWORD_SETTING]: '비밀번호 관리',
  [MyMenuContent.CHECK_WORK_HOURS]: '근무 시간 조회',
  [MyMenuContent.CHECK_OVERTIME]: '연장근무 내역 조회',
  [MyMenuContent.CHECK_VACATION]: '휴가 현황 조회',
  [MyMenuContent.CERTIFICATE_OF_EMPLOYMENT]: '재직증명서 발급',
  [MyMenuContent.PAY_STUB]: '급여명세서 조회',
  [MyMenuContent.SHOPPING_MALL_VERIFICATION]: '바닐라닷컴 직원할인 인증',
  [MyMenuContent.WIFI]: '방문자 와이파이 인증',
  [MyMenuContent.OLIVE]: '구내식당 이용 안내',
  [MyMenuContent.WALLET]: '출입 정보',
  [MyMenuContent.SETTINGS]: '설정',
  [MyMenuContent.WORKING_HOURS_CHANGE]: '근무 시간 변경 신청',
  [MyMenuContent.PORTAL_APP_DOWNLOAD]: 'Portal App',
  [MyMenuContent.HEALTH_CARE_BOOKING]: '건강관리실 예약',
};

type MyMenuContentMapValue = { component: any; hasSidePadding: boolean };

export const MyMenuContentMap = new Map<MyMenuContent, MyMenuContentMapValue>([
  [
    MyMenuContent.EDIT_PROFILE,
    { component: EditProfileContent, hasSidePadding: false },
  ],
  [
    MyMenuContent.PERSONAL_INFO,
    { component: PersonalInfoContent, hasSidePadding: true },
  ],
  [
    MyMenuContent.MAIL_SIGNATURE,
    { component: MailSignatureContent, hasSidePadding: true },
  ],
  [
    MyMenuContent.LANGUAGE_SETTING,
    { component: LanguageSettingContent, hasSidePadding: true },
  ],
  [
    MyMenuContent.ALARM_SETTING,
    { component: AlarmSettingContent, hasSidePadding: true },
  ],
  [
    MyMenuContent.PASSWORD_SETTING,
    { component: PasswordSettingContent, hasSidePadding: true },
  ],
  [
    MyMenuContent.CHECK_WORK_HOURS,
    { component: WorkHours, hasSidePadding: false },
  ],
  // 연장근무 내역 조회 (A, HC 법인만 노출)
  [
    MyMenuContent.CHECK_OVERTIME,
    { component: Overtime, hasSidePadding: false },
  ],
  [
    MyMenuContent.CHECK_VACATION,
    { component: Vacation, hasSidePadding: false },
  ],
  [
    MyMenuContent.CERTIFICATE_OF_EMPLOYMENT,
    { component: CertificateOfEmployment, hasSidePadding: true },
  ],
  [MyMenuContent.PAY_STUB, { component: PayStubContent, hasSidePadding: true }],
  [
    MyMenuContent.SHOPPING_MALL_VERIFICATION,
    { component: ShoppingMallVerification, hasSidePadding: true },
  ],
  [MyMenuContent.WIFI, { component: WifiContent, hasSidePadding: true }],
  [MyMenuContent.OLIVE, { component: Olive, hasSidePadding: false }],
  [MyMenuContent.WALLET, { component: Wallet, hasSidePadding: false }],
  [MyMenuContent.SETTINGS, { component: Settings, hasSidePadding: false }],
  [
    MyMenuContent.WORKING_HOURS_CHANGE,
    { component: WorkingHoursChange, hasSidePadding: true },
  ],
  [
    MyMenuContent.PORTAL_APP_DOWNLOAD,
    { component: PortalAppDownload, hasSidePadding: false },
  ],
]);

/**
 * 서브메뉴 대신 포탈 밖 주소로 이동하는 항목. 여기에 등록된 항목은
 * MyMenuContentMap 에 넣지 않고, 클릭하면 새 탭(앱은 외부 브라우저)으로 열린다.
 */
export const MyMenuExternalUrlMap = new Map<MyMenuContent, string>([
  [MyMenuContent.HEALTH_CARE_BOOKING, HEALTH_CARE_BOOKING_URL],
]);
